import { Controller } from '@hotwired/stimulus'
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe from 'photoswipe'

export default class extends Controller {
  static targets = ['children']

  connect () {
    if (this.hasChildrenTarget) {
      this.lightbox = new PhotoSwipeLightbox({
        gallery: this.element,
        children: this.childrenTargets,
        showHideAnimationType: 'zoom',
        initialZoomLevel: 'fit',
        secondaryZoomLevel: 'fit',
        maxZoomLevel: 2,
        zoom: true,
        counter: false,
        bgOpacity: 0.8,
        arrowPrevSVG: this._leftArrowSVGString,
        arrowNextSVG: this._leftArrowSVGString,
        closeSVG: this._closeSVGString,
        pswpModule: PhotoSwipe
      })

      this.lightbox.init()
    }
  }

  disconnect () {
    if (this.lightbox) this.lightbox.destroy()
  }

  get _leftArrowSVGString () {
    return '<svg xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" class="pswp__icn" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" /></svg>'
  }

  get _closeSVGString () {
    return '<svg xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" class="pswp__icn" viewBox="0 0 24 24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>'
  }
}
